import { render, staticRenderFns } from "./CampaignDiscountList.vue?vue&type=template&id=b6a4e9d8&"
import script from "./CampaignDiscountList.vue?vue&type=script&lang=js&"
export * from "./CampaignDiscountList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports